import { Tooltip } from '@ds';
import { MdOutlineInfo } from 'react-icons/md';

const REDACTION_INSTRUCTIONS_TEXT =
  'The donor summary must be de-identified before upload. Remove any information that could identify the donor, including names, contact information, dates, locations, medical record numbers, or other identifiers.';

export const RedactionConfirmationInstructions = () => (
  <div className="flex items-center gap-2 pb-4 shrink-0">
    <span className="text-s-r text-base-20">Remove identifying information before uploading</span>
    <Tooltip className="max-w-80 opacity-90" content={REDACTION_INSTRUCTIONS_TEXT}>
      <span className="flex items-center text-base-30">
        <MdOutlineInfo size={16} />
      </span>
    </Tooltip>
  </div>
);
